import { useSyncExternalStore } from "react";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onStoreChange: () => void) {
  const mq = window.matchMedia(REDUCED_MOTION_QUERY);
  mq.addEventListener("change", onStoreChange);
  return () => mq.removeEventListener("change", onStoreChange);
}

function getSnapshot() {
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

// Server render assumes motion is allowed; the real value is picked up on the
// first client render after hydration.
function getServerSnapshot() {
  return false;
}

/** Returns true when parallax/wave effects should be skipped (prefers-reduced-motion). */
export function useSkipAnimations() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
